var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecoundPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8983 10.7422L14.1608 17.8472C14.1749 17.9309 14.1632 18.0168 14.1271 18.0936C14.0911 18.1705 14.0324 18.2344 13.959 18.277C13.8857 18.3196 13.801 18.3388 13.7164 18.3319C13.6319 18.3251 13.5514 18.2926 13.4858 18.2389L10.5024 15.9997C10.3584 15.8921 10.1835 15.834 10.0037 15.834C9.82391 15.834 9.64896 15.8921 9.50494 15.9997L6.5166 18.238C6.45104 18.2917 6.37065 18.3241 6.28618 18.331C6.20171 18.3378 6.11716 18.3187 6.04382 18.2762C5.97048 18.2338 5.91183 18.17 5.8757 18.0933C5.83957 18.0166 5.82768 17.9308 5.8416 17.8472L7.10327 10.7422",
    stroke: "#C0C0C0",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6641C12.7614 11.6641 15 9.42549 15 6.66406C15 3.90264 12.7614 1.66406 10 1.66406C7.23858 1.66406 5 3.90264 5 6.66406C5 9.42549 7.23858 11.6641 10 11.6641Z",
    stroke: "#C0C0C0",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecoundPlace);
export default __webpack_public_path__ + "static/media/secoundPlace.3505d74f38e352a0a51be3dd23604159.svg";
export { ForwardRef as ReactComponent };